export const SET_ACTIVE_MODULE = "SET_ACTIVE_MODULE";

export const setActiveModule = (moduleName) => {
    return {
        type: SET_ACTIVE_MODULE,
        payload: moduleName,
    };
};
